import { useContext, useState, useEffect, useRef } from 'react';
import PageContext from './PageContext';
import { HttpContext } from '../../api-services/HttpService';
import OrderedDataTable from './OrderedDataTableCopy.jsx';
import SubCompanyRow from './SubCompanyRow';
import CCOffcanvas from './CCOffcanvas.tsx';
import ButtonComponent from './ButtonComponent.jsx';

const ViewSubCompaniesModal = ({ flag, headerKey }) => {
    // get context variables from parent
    const {
        viewModal, 
        setViewModal, 
        viewCompany, 
        setViewCompany, 
    } = useContext(PageContext);
    // initialize http context 
    const {
        GET,  
    } = useContext(HttpContext);
    // initialize table state
    const [subCompanyDataList, setSubCompanyDataList] = useState([{}]);
    const [subCompanyTableHeader, setSubCompanyTableHeader] = useState([{}]);
    const [showSpinner, setShowSpinner] = useState(false);
    const [header, setHeader] = useState(''); 
    // initialize useRef for initial render
    const initialRender = useRef(true);

    // function wrapper to pass row component to DataTable
    const RowComponent = (row, count, tableHeader,stickyEnabled) => {
        return(
            <>
                <SubCompanyRow row={row} count={count} tableHeader={tableHeader} stickyEnabled={stickyEnabled}/>
            </>
        );
    }

    // make http request to get sub companies for given company
    const getCompanyData = () => {
        return new Promise ((resolve, reject) => {
            setShowSpinner(showSpinner => showSpinner = true);
            console.log(viewCompany); 
            // initialize route and arguments
            let path = '/data/subCompanyData'; 
            let args = {
                mastercompany: viewCompany['mastercompanyname'], 
                mastercompanyid: viewCompany['mastercompanyid'], 
            }; 
            // pick route and arguments based on flag
            if (flag === 1) {
                path = '/consortium/masterCompanyModalData'; 
                args = {
                    consortiumid: viewCompany['consortiumid'], 
                }
            }
            // use GET function to make request
            GET(path, args).then(res => {
                // set table state
                setSubCompanyDataList(subCompanyDataList => subCompanyDataList = res['data']['SubCompanyData']);
                setSubCompanyTableHeader(subCompanyTableHeader => subCompanyTableHeader = res['data']['SubCompanyCols']);
                // set show spinner to false
                setShowSpinner(showSpinner => showSpinner = false);
                resolve(res);
            }).catch(err => {
                // show show spinner to false
                setShowSpinner(showSpinner => showSpinner = false);
                reject(err);
            });
        });
    }

    // useEffect to run when view company changes
    useEffect(() => {
        //do not run on initial render
        if (initialRender.current){
            initialRender.current = false;
        }
        else{
            // set header
            if (headerKey) {
                setHeader(header => header = viewCompany[headerKey]); 
            }
            else {
                setHeader(header => header = viewCompany['mastercompanyname']); 
            }
            // get sub companies for view company
            getCompanyData().then(res => {
                console.log(res);
            }).catch(err => {
                console.log(err);
            });
        }
    }, [viewCompany]);

    return(
        <> 
            <CCOffcanvas 
                title={header}
                show={viewModal}
                onCanvasClose={()=>setViewModal(viewModal => viewModal = false)}
                bodyCssClassName="offcanvas-body"
                offCanvasClassName="offcanvas-parent-card"
                >
                    <div className="d-flex flex-column h-100">
                        <div className="p-3 pt-1 trail-section flex-grow-1 overflow-scroll">
                            <div className="bg-white trail-card">
                                <OrderedDataTable stickyFirstColumnEnabled={true} sortingEnabled={true} disableMaxTableHeight={true} RowComponent={RowComponent} tableHeader={subCompanyTableHeader} dataList={subCompanyDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='14vh'/>
                            </div>
                        </div>
                        <div
                            className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                        >
                            <ButtonComponent
                                tag={"OK"}
                                border={'#fcd800 1px solid'}
                                background={'#fcd800'}
                                color={'#001317'}
                                onButtonClick={()=>setViewModal(viewModal => viewModal = false)}
                            />
                        </div>
                    </div>
            </CCOffcanvas>
        </>
    );
}

export default ViewSubCompaniesModal;